export const GTM_ID = 'GTM-WB39ZM' as const;

export const GTM_SERVER_ID = 'GTM-NFZNVLS6' as const;
